import ForbiddenError from './error';
import env from './env';

export const getCustomerTree = (data, parent = null, level = 0) => {
  let nodes = [];
  for (const id in data) {
    if (data[id].parent_id == parent) {
      nodes.push({ _id: id, ...data[id] });
    }
  }
  nodes.sort((a, b) => a.name.localeCompare(b.name));

  let customers = [];
  for (const node of nodes) {
    customers.push({
      ...node,
      level: level,
      prefix: '--'.repeat(level),
    });
    const children = getCustomerTree(data, node._id, level + 1);
    for (const child_id in children) {
      customers.push({
        ...children[child_id],
        level: level + 1,
        prefix: '--'.repeat(level + 1),
      });
    }
  }
  return customers;
};

export const getCustomerHierarchy = (data) => {
  let customers = [];

  const sortedAllowed = [...data['allowed']].sort((a, b) => {
    const nameA = a != null ? data['customers'][a]?.name ?? '' : '';
    const nameB = b != null ? data['customers'][b]?.name ?? '' : '';
    return nameA.localeCompare(nameB);
  });

  for (const parent_id of sortedAllowed) {
    var level = 0;
    if (parent_id != null) {
      customers.push({
        ...data['customers'][parent_id],
        level: 0,
        prefix: '',
      });
      level = 1;
    }

    const children = getCustomerTree(data['customers'], parent_id, level);
    for (const y in children) {
      customers.push(children[y]);
    }
  }
  return customers;
};

export const fetchCustomers = async (token) => {
  return await fetch(env('REACT_APP_BACKEND_URL') + '/v1/customers', {
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    },
  })
    .then((response) => {
      // 200 | 403
      if (response.ok || response.status == 403) {
        return {
          status: response.status,
          message: response.json(),
        };
      }
      // ?
      throw response.json();
    })
    .then((response) => {
      if (response['status'] == 403) {
        throw new ForbiddenError(response['message']['detail']);
      } else {
        return response['message'];
      }
    })
    .catch((error) => {
      if (error instanceof ForbiddenError) {
        throw error;
      }
      if (error instanceof TypeError) {
        throw new Error(error.message);
      }
      return error.then((text) => {
        throw new Error(text['detail']);
      });
    });
};

export const fetchCustomer = async (token, customer_id) => {
  return await fetch(env('REACT_APP_BACKEND_URL') + '/v1/customer/' + customer_id, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    },
  })
    .then((response) => {
      // 200 | 403
      if (response.ok || response.status == 403) {
        return {
          status: response.status,
          message: response.json(),
        };
      }
      // ?
      throw response.json();
    })
    .then((response) => {
      if (response['status'] == 403) {
        throw new ForbiddenError(response['message']['detail']);
      } else {
        return response['message'];
      }
    })
    .catch((error) => {
      if (error instanceof ForbiddenError) {
        throw error;
      }
      if (error instanceof TypeError) {
        throw new Error(error.message);
      }
      return error.then((text) => {
        throw new Error(text['detail']);
      });
    });
};

export const fetchCustomerHosts = async (token, customer_id) => {
  return await fetch(env('REACT_APP_BACKEND_URL') + '/v1/customer/' + customer_id + '/hosts', {
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    },
  })
    .then((response) => {
      // 200 | 403
      if (response.ok || response.status == 403) {
        return {
          status: response.status,
          message: response.json(),
        };
      }
      // ?
      throw response.json();
    })
    .then((response) => {
      if (response['status'] == 403) {
        throw new ForbiddenError(response['message']['detail']);
      } else {
        return response['message'];
      }
    })
    .catch((error) => {
      if (error instanceof ForbiddenError) {
        throw error;
      }
      if (error instanceof TypeError) {
        throw new Error(error.message);
      }
      return error.then((text) => {
        throw new Error(text['detail']);
      });
    });
};
